<template>
    <div class="estimates-template">
        <h4>Template Name: <span>{{template.name}}</span></h4>
        <div class="template-modify-info">
            <span>Created By:</span>
            <span><a href="#">{{template.created_by}} - {{template.created_on}}</a></span>
            <span>Last Updated:</span>
            <span><a href="#">{{template.updated_on}}</a></span>
            <span>Updated By:</span>
            <span><a href="#">{{template.updated_by}}</a></span>
            <a v-if="isStatusActive" @click="saveEstimateTemplate()" href="#" class="btn btn-primary clickable w-min-sm waves-effect waves-light btn-right">Save</a>
        </div>
        <div class="row">
            <div class="col-md-3" style="padding:0">
                <div class="left-side">
                    <div class="p-20">
                        <label for="search" class="search-label"></label>
                        <input type="text" class="filed-md search-field" v-model="magicSearchEstimateTemplate" id="search" placeholder="Search templates">

                        <hr>

                        <h3 class="mt-3">Create New Template</h3>
                        <div class="text-right">
                            <input type="text" class="filed-md" v-model="new_estimate_template_name" id="name" placeholder="Name">
                            <a @click="createEstimateTemplate" href="#" class="btn btn-primary mt-1 mb-1 clickable">Create</a>
                        </div>


                        <hr>

                        <h3 class="mt-3 mb-0 ">Template Library</h3>
                    </div>
                    <ul class="left-side-nav">
                        <li v-for="(item, index) in estimateTemplates">
                            <div style="width:80%; margin-top:-5px" v-if="item.id == template.id && template.id > 0">
                                <input :readonly="!isStatusActive" type="text" ref="name" class="form-control" v-model="template.name"/>
                            </div>
                            <div style="width:75%" v-else class="clickable" @click="editEstimateTemplate(item.id)">{{item.name}}</div>
                            <div>
                                <button @click="editEstimateTemplate(item.id)" class="btn btn_edit"></button>
                                <button @click="removeEstimateTemplate(item.id)" class="btn btn_trush"></button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-md-9" v-show="isCurrentTemplate" style="padding:0">

                <tabs :options="{ useUrlFragment: false}" class="template-tabs" :topGap="false">
                    <tab name="Items List" id="items_list">
                        <div class="estimate-edit">
                            <!--<div :class="{'col-md-5': selectedCard == 'Part', 'col-md-6': selectedCard != 'Part', 'text-center': true}">-->
                            <div class="tabs-component">
                                <!-- <div class="navbar navbar-light bg-grey navbar-bottom-line b-a mb-2"> -->
                                <ul class="nav nav-tabs nav-tabs-2 mb-1 float-sm-left">
                                    <li @click.prevent="selectCard('RR')" class="tabs-component-tab nav-item">
                                        <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'RR'}">RR</a>
                                    </li>
                                    <li @click.prevent="selectCard('Repair')" class="tabs-component-tab nav-item">
                                        <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Repair'}">Repair</a>
                                    </li>
                                    <li @click.prevent="selectCard('Paint')" class="tabs-component-tab nav-item">
                                        <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Paint'}">Paint</a>
                                    </li>
                                    <li @click.prevent="selectCard('Part')" class="tabs-component-tab nav-item">
                                        <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Part'}">Parts</a>
                                    </li>
                                    <li @click.prevent="selectCard('Sublet')" class="tabs-component-tab nav-item">
                                        <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Sublet'}">Sublet</a>
                                    </li>
                                    <li @click.prevent="selectCard('Other')" class="tabs-component-tab nav-item">
                                        <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Other'}">Other</a>
                                    </li>
                                </ul>
                                <!-- </div> -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="box">
                                            <ul class="nav nav-4 vh-height-75">
                                                <li :class="{'nav-item': true, 'magic-search-box': magicSearchEnabled}">
                                                    <div>
                                                        <input v-model="magicSearchCardPart" type="text" class="nav-link search-input"
                                                               style="height: 3rem;font-weight:normal; border:none !important;"
                                                               :placeholder="'Search'">

                                                    </div>
                                                </li>
                                                <li :class="{'nav-item': true, 'active': selectedCardPart == cp}" v-for="cp in cardParts">
                                                    <a class="nav-link" @click.prevent="selectCardPart(cp)" href="#">{{cp}}
                                                        <div class="float-xs-right"><i class="fa fa-angle-right"></i></div>
                                                    </a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="box">
                                            <ul class="nav nav-4 vh-height-75">
                                                <li :class="{'nav-item': true, 'magic-search-box': magicSearchEnabled}">
                                                    <div>
                                                        <input v-model="magicSearchSubCardPart" type="text" class="nav-link search-input"
                                                               style="height: 3rem;font-weight:normal; border:none !important;"
                                                               :placeholder="'Search'">

                                                    </div>
                                                </li>
                                                <li class="nav-item"><a class="nav-link new-estimate-item" @click.prevent="selectCardSubPart('', true)" href="#"><i class="ti-plus"></i>New Item

                                                </a></li>
                                              <draggable
                                                  v-model="test"
                                                  class="dragArea"
                                                  handle=".handle"
                                                  :animation="150"
                                                  :group="{ name: 'items', pull: 'clone', put: false }"
                                                  :clone="cloneItem"
                                                  :delayOnTouchOnly="true"
                                                  @start="onDragStart"
                                                  :disabled="!isStatusActive"
                                                  @end="onDragEnd"
                                              >
                                                <li v-for="(cs, index) in cardSubParts"
                                                    :class="{'border-top-groups': true}"
                                                    class="handle"
                                                >
                                                  <rs-ripple>
                                                    <a class="nav-link" @click.prevent="selectCardSubPart(cs)" href="#">{{ cs.prt }}
                                                      <div class="float-xs-right"><i class="fa fa-angle-right"></i></div>
                                                    </a>
                                                  </rs-ripple>
                                                </li>
                                              </draggable>

<!--                                                <li :class="{'nav-item': true, 'active': selectedCardSubPart == cs}" v-for="cs in cardSubParts">-->
<!--                                                    <a class="nav-link"-->
<!--                                                        @click.prevent="selectCardSubPart(cs)"-->
<!--                                                        href="#">-->
<!--                                                            {{cs.prt}}-->
<!--                                                    <div class="float-xs-right">-->
<!--                                                        <i class="fa fa-angle-right"></i>-->
<!--                                                    </div>-->
<!--                                                </a></li>-->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-7 vh-height-75" id="estimate-item-list">
                                <!-- <div class="box bg-grey"> -->
                                <!-- <p v-if="availableCards.length">No records selected. Please click on items available in two panes on the left side.</p> -->
                                <vue-context ref="rightClickMenuForRR">
                                    <ul slot-scope="item">
                                        <li @click="onRightClickByRR($event.target, {type:5, index:item.data})">Add to Paint</li>
                                        <li @click="onRightClickByRR($event.target, {type:2, index:item.data})">Insert Row</li>
                                        <li @click="onRightClickByRR($event.target, {type:3, index:item.data})">Delete Row</li>
                                    </ul>
                                </vue-context>
                                <vue-context ref="rightClickMenuForRepair">
                                    <ul slot-scope="item">
                                        <li @click="onRightClickByRepair($event.target, {type:5, index:item.data})">Add to Paint</li>
                                        <li @click="onRightClickByRepair($event.target, {type:2, index:item.data})">Insert Row</li>
                                        <li @click="onRightClickByRepair($event.target, {type:3, index:item.data})">Delete Row</li>
                                    </ul>
                                </vue-context>
                                <vue-context ref="rightClickMenuForPaint">
                                    <ul slot-scope="item">

                                        <li @click="onRightClickByPaint($event.target, {type:2, index:item.data})">Insert Row</li>
                                        <li @click="onRightClickByPaint($event.target, {type:3, index:item.data})">Delete Row</li>
                                    </ul>
                                </vue-context>
                                <vue-context ref="rightClickMenuForPart">
                                    <ul slot-scope="item">
                                        <li @click="onRightClickByPart($event.target, {type:2, index:item.data})">Insert Row</li>
                                        <li @click="onRightClickByPart($event.target, {type:3, index:item.data})">Delete Row</li>
                                    </ul>
                                </vue-context>
                                <vue-context ref="rightClickMenuForSublet">
                                    <ul slot-scope="item">
                                        <li @click="onRightClickBySublet($event.target, {type:2, index:item.data})">Insert Row</li>
                                        <li @click="onRightClickBySublet($event.target, {type:3, index:item.data})">Delete Row</li>
                                    </ul>
                                </vue-context>
                                <vue-context ref="rightClickMenuForOther">
                                    <ul slot-scope="item">
                                        <li @click="onRightClickByOther($event.target, {type:2, index:item.data})">Insert Row</li>
                                        <li @click="onRightClickByOther($event.target, {type:3, index:item.data})">Delete Row</li>
                                    </ul>
                                </vue-context>
                                <div v-for="card in availableCards" :class="{'display-none': card != selectedCard, 'card': true}">
                                    <div class="card-header bg-navyblue">
                                        <strong>{{card}}</strong>
                                    </div>

                                    <div class="card-block rs-scroll rs-scroll--x rs-scroll--y px-0 py-0 bg-white template-estimate-items-wrapper" style="overflow: auto;">
                                        <div class="mb-1 template-estimate-items" id="table-1"
                                            style="margin-bottom: 14rem !important;"
                                            :class="{'template-width-paint': card === 'Paint', 'template-width-parts': card === 'Part', 'template-width-other': card === 'Other' || card === 'Sublet' || card === 'Repair' || card === 'RR'}"
                                        >
                                            <div>
                                                <div class="template-estimate-items-title">
                                                    <div class="estimate-items-name-all" style="padding-left: 15px;" >Name</div>
                                                    <div v-if="card === 'Part'" class="text-center numeric estimate-items-title-content estimate-items-part-num">Part Number</div>
                                                    <div v-if="card === 'Part'" class="text-center numeric estimate-items-title-content estimate-items-part-num">Type</div>
                                                    <div v-if="card === 'Part'" class="text-center numeric numeric-qty estimate-items-title-content">Qty</div>
                                                    <div v-if="card === 'Paint'" class="text-center numeric estimate-items-title-content estimate-items-paint-materials">Paint Material</div>
                                                    <div v-if="card !== 'Part' && card !== 'Other' && card !== 'Sublet'" class="text-center estimate-items-title-content estimate-items-hrs">Hrs</div>
                                                    <div v-if="card !== 'Other' && card !== 'Sublet' && card !== 'Materials'" class="text-center numeric estimate-items-title-content estimate-items-rate">{{card == 'Part' ? 'List' : 'Rate'}}</div>
                                                    <div class="text-center numeric estimate-items-title-content estimate-items-total">Total</div>
                                                    <div class="estimate-items-content-btn-remove"></div>
                                                </div>
                                            </div>
                                            <draggable
                                                v-model="itemParts[card]"
                                                class="dragArea"
                                                :element="'div'"
                                                :disabled="!isStatusActive || isDraggableDisabled"
                                                @change="onItemMoveChange"
                                                @add="onDragAdd"
                                                @start="onDragEstimateItemStart"
                                                @end="onDragEstimateItemEnd"
                                                handle=".handle"
                                                :animation="150"
                                                :group="{
                                                    name: 'items',
                                                    put: true // not allow(false) or allow(true) items to be put into this list
                                                }"
                                                ghost-class="ghost-items"
                                                style="margin: 0 5px"


                                            >
                                              <template v-for="(part, index) in itemParts[card]">
                                                <estimate-item :ref="card + index"
                                                               :isTemplate="true"
                                                               :isEstimateTemplate="true"
                                                               :card="card"
                                                               :key="card + '-' + index"
                                                               :isMovedElement="computedIsMovedDraggableElement"
                                                               v-bind="part"
                                                               :item="part"
                                                               :properties="{}"
                                                               @update:item="val => itemParts[card][index] = val"
                                                               :index="'part-'+card+'-' + (index + 1)"
                                                               @remove="removeItemPart(card,index)"
                                                               @onKeyPress="onKeyPress"
                                                               @updateDrag="v => isDraggableDisabled = !v"
                                                               @dragenter="itemOnMouseenter"
                                                               @dragover="itemOnMouseover"
                                                               @dragleave="itemOnMouseleave"
                                                               @onKeyPressEnter="onEnterKeyPress(index)"
                                                               @onKeyPressLeft="onLeftKeyPress(index, ...arguments)"
                                                               @onKeyPressRight="onRightKeyPress(index, ...arguments)"
                                                               @onKeyPressUp="onUpKeyPress(index, ...arguments)"
                                                               @onKeyPressDown="onDownKeyPress(index, ...arguments)"
                                                               @openRightMenuForPaint="openMenuPaint($event, index)"
                                                               @openRightMenuForRR="openMenuRR($event, index)"
                                                               @openRightMenuForRepair="openMenuRepair($event, index)"
                                                               @openRightMenuForPart="openMenuPart($event, index)"
                                                               @openRightMenuForSublet="openMenuSublet($event, index)"
                                                               @openRightMenuForOther="openMenuOther($event, index)"
                                                >
                                                </estimate-item>
                                              </template>
                                            </draggable>
                                        </div>
                                    </div>
                                </div>


                                <!-- </div> -->
                            </div>
                        </div>
                    </tab>
                    <tab name="Images" id="images">
                        <div>
                            <vue-dropzone v-on:vdropzone-file-added="addImgUpload" v-on:vdropzone-success="successImgUpload" v-on:vdropzone-complete="completeImgUpload"
                                          v-on:vdropzone-sending="sendImgUpload" ref="imgUpDrop" v-if="isStatusActive"
                                          id="imgUploadDrop" class="dropify-wrapper dropzoneContainer" style="height: auto;" :options="imageUploadDropzoneOptions" :useCustomSlot=true>
                                <div class="dropify-message" style="transform: translateY(0%);">
                                  <i class='bx bx-cloud-upload' ></i>
                                  <p class="drop-down-text">Drag and Drop Images Here</p>
                                  <p class="text-or mb-0-5">Or</p>
                                  <div class="text-sm-center mb-1">
                                    <button type="button" class="btn btn-primary waves-effect waves-light estimates-template-btn"><i class="ti-search"></i> Browse</button>
                                    <button @click="clickCancelDropzoneImages" type="button" class="btn btn-secondary waves-effect waves-light estimates-template-btn"><i class="ti-close"></i> Cancel</button>
                                  </div>
                                </div>
                            </vue-dropzone>
                        </div>

                        <div class="row">
                            <image-lightbox :imageList="imageSource" @removeImage="deleteImage" :path="''"></image-lightbox>
                        </div>
                    </tab>
                    <tab name="Docs" id="files">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-1">
                                    <vue-dropzone v-on:vdropzone-removed-file="removeFileDropzone" v-on:vdropzone-file-added="addFileUpload" v-on:vdropzone-complete="completeFileUpload"
                                                  v-on:vdropzone-sending="sendFileUpload" v-on:vdropzone-success="successFileUpload" ref="fileUpDrop" id="fileUploadDrop"
                                                  class="dropify-wrapper dropzoneContainer" style="height: auto;" v-if="isStatusActive"
                                                  :options="fileUploadDropzoneOptions" :useCustomSlot=true>
                                        <div class="dropify-message" style="transform: translateY(0%);">
                                          <i class='bx bx-cloud-upload' ></i>
                                          <p class="dnd-title">Drag and Drop Doc Here</p>
                                          <p class="text-or mb-0-5 dnd-or">Or</p>
                                          <div class="text-sm-center mb-1">
                                            <button type="button" class="btn btn-primary waves-effect waves-light estimates-template-btn"><i class="ti-search"></i> Browse
                                            </button>
                                            <button @click="clickCancelDropzoneFiles" type="button" class="btn btn-secondary waves-effect waves-light estimates-template-btn"><i class="ti-close"></i> Cancel
                                            </button>
                                          </div>
                                        </div>
                                    </vue-dropzone>

                                </div>
                                <div class="row" style="height: 48vh">
                                    <div class="col-md-12 pagination-block-bottom" style="padding-bottom: 0 !important">
                                      <b-table
                                        responsive
                                        hover
                                        :items="files"
                                        :fields="fields"
                                        :current-page="cardsCurrentPage"
                                        :per-page="cardsPerPage"
                                      >
                                        <template v-slot:cell(name)="data">
                                          <a class="file-name" :download="data.item.name" href="">{{data.item.name}}</a>
                                        </template>
                                        <template v-slot:cell(uploaded_by)="data">
                                          <span class="uploaded-by">{{data.item.user}}</span>
                                        </template>
                                        <template v-slot:cell(created_by)="data">
                                          <span class="uploaded-date">{{data.item.date}}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                          <a @click="remTableFile(data.item.id)" class="trash-icon">
                                            <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <!-- Generator: sketchtool 60.1 (101010) - https://sketch.com -->
                                              <title>EFD4E02B-E531-48FD-903C-7C1EC7568772</title>
                                              <desc>Created with sketchtool.</desc>
                                              <g id="UI-Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="Dashboard-Redesign-(Detail-Cards)Files" transform="translate(-1264.000000, -933.000000)" fill="#FF5E5E" fill-rule="nonzero">
                                                  <g id="Group-4" transform="translate(265.000000, 933.000000)">
                                                    <g id="trash" transform="translate(999.000000, 0.000000)">
                                                      <path d="M6,2 L6,1 C6,0.44771525 6.44771525,0 7,0 L11,0 C11.5522847,0 12,0.44771525 12,1 L12,2 L16,2 C17.1045695,2 18,2.8954305 18,4 L18,5 C18,6.1045695 17.1045695,7 16,7 L15.867,7 L15.187,17.2 C15.081727,18.775582 13.773095,20 12.194,20 L5.826,20 C4.24834545,20 2.94028051,18.7780028 2.833,17.204 L2.137,7 L2,7 C0.8954305,7 0,6.1045695 0,5 L0,4 C0,2.8954305 0.8954305,2 2,2 L6,2 Z M16,4 L2,4 L2,5 L16,5 L16,4 Z M4.141,7 L4.828,17.068 C4.86376888,17.5927957 5.29998676,18.0001655 5.826,18 L12.194,18 C12.7207338,18 13.1572356,17.5915853 13.192,17.066 L13.862,7 L4.142,7 L4.141,7 Z M7,8 C7.55228475,8 8,8.44771525 8,9 L8,16 C8,16.5522847 7.55228475,17 7,17 C6.44771525,17 6,16.5522847 6,16 L6,9 C6,8.44771525 6.44771525,8 7,8 Z M11,8 C11.5522847,8 12,8.44771525 12,9 L12,16 C12,16.5522847 11.5522847,17 11,17 C10.4477153,17 10,16.5522847 10,16 L10,9 C10,8.44771525 10.4477153,8 11,8 Z" id="Shape"></path>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </svg>
                                          </a>
                                        </template>
                                      </b-table>
                                    </div>
                                    <block-pagination
                                        :role="'Docs'"
                                        :count="files.length"
                                        :countFiltered="files.length"
                                        :currentPage="cardsCurrentPage"
                                        @changedCurrentPage="value => cardsCurrentPage = value"
                                        :perPage="cardsPerPage"
                                        @changedPerPage="value => cardsPerPage = value"
                                    >
                                    </block-pagination>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import {appConfig} from '../../config.js';
    import Axios from 'axios';
    import _ from 'lodash';
    import draggable from 'vuedraggable';
    import {VueContext} from 'vue-context';
    import DatePicker from '../utility/date-picker';
    import FileUploader from '../utility/file-uploader';
    import ImageLightbox from '../utility/image-lightbox';
    import NumberFormatter from '../utility/number-formatter';
    import EstimateItem from '../utility/estimate-item';
    import AmazonAds from '../utility/amazon-ads';
    import AdvancedSearch from '../utility/advanced-search';
    import ImageSelector from '../utility/image-selector';
    import SiteFooter from '../common/site-footer';
    import ActivityReplyMessage from '../activity-reply-message';
    import vue2Dropzone from 'vue2-dropzone';
    import GoogleLocation from '../utility/google-location';
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';
    import BlockPagination from '../utility/block-pagination';
    import {mapGetters} from "vuex";
    import dragDropItems from '../../mixins/drag-drop-items'
    import RsRipple from '../../components/rs-ripple'

    export default {
        mixins: [
          dragDropItems,
        ],
        name: "estimate-templates",
        data: function () {
            return {
                isEstimatesTemplates: true,
                test: [],
                rates: {
                  paint_material: 'not_set',
                  paint: 0,
                  repair: 0,
                  rr: 0,
                },
                originalData: '',
                isDraggableDisabled: false,
                new_estimate_template_name: '',
                template: {
                    id: 0,
                    created_on: '',
                    created_by: '',
                    updated_on: '',
                    updated_by: '',
                    name: '',
                },
                isMovedElement: false,
                files: [],
                file_ids: [],
                removeFiles: [],
                images: [],
                image_ids: [],
                removeImages: [],
                itemParts: {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Sublet': [],
                    'Other': []
                },
                removeItemParts: {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Sublet': [],
                    'Other': []
                },
                ET: [],
                imageUploadDropzoneOptions: {
                    headers: { "Authorization": localStorage.getItem('token') },
                    url: appConfig.baseAPIURL+'/fe/card/uploadImagesDropzone',
                    method: 'post',
                    maxFilesize: 5,
                    // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
                    thumbnailWidth: 200,
                    addRemoveLinks: false,
                    acceptedFiles: 'image/jpeg, image/jpg, image/png',
                    dictFileTooBig: "Your image has exceeded the maximum limit of 5MB per image. Please reduce the image size and upload again",
                },
                fileUploadDropzoneOptions: {
                     headers: { "Authorization": localStorage.getItem('token') },
                    url: appConfig.baseAPIURL+'/fe/card/uploadFilesDropzone',
                    method: 'post',
                    maxFilesize: 5,
                    // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    acceptedFiles: 'application/pdf, .doc, .docx',
                    dictFileTooBig: "Your doc has exceeded the maximum limit of 5MB per doc. Please reduce the file size and upload again",
                },
                magicSearchEnabled: false,
                magicSearchEstimateTemplate: '',
                magicSearchTerm: '',
                magicSearchCardPart: '',
                magicSearchSubCardPart: '',
                selectedCard: 'RR',
                selectedCardPart: 'FRONT BAR',
                selectedCardSubPart: '',
                sort: [],
                drImageOptions: {
                    messages: {
                        'default': 'Drag and drop an image here or click to select it from your computer',
                        'replace': 'Drag and drop or click to add new image',
                        'remove': 'Remove',
                        'error': 'Ooops, something went wrong.'
                    }
                },
                drFilesOptions: {
                    messages: {
                        'default': 'Drag and drop a file here or click to select it from your computer',
                        'replace': 'Drag and drop or click to add new file',
                        'remove': 'Remove',
                        'error': 'Ooops, something went wrong.'
                    }
                },
                error: {
                    exists: false,
                    messages: []
                },
                fields: [{
                  label: 'Doc Name',
                  key: 'name',
                  sortable: true,
                  tdClass: 'file-name'
                },
                  {
                    label: 'Uploaded By',
                    key: 'uploaded_by',
                    sortable: true,
                    tdClass: 'uploaded-by'
                  },
                  {
                    label: 'Date',
                    key: 'created_by',
                    sortable: true,
                    tdClass: 'uploaded-date'
                  },
                  {
                    label: 'Action',
                    key: 'action',
                    tdClass: 'action'
                  }
                ],
                cardsPerPage: 10,
                cardsCurrentPage: 1,
            };
        },
        methods: {
            initCurrentTemplate: function () {
                this.itemParts = {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Sublet': [],
                    'Other': []
                };
                this.removeItemParts = {
                    'RR': [],
                    'Repair': [],
                    'Paint': [],
                    'Part': [],
                    'Sublet': [],
                    'Other': []
                };
                this.files = [];
                this.file_ids = [];
                this.image_ids = [];
                this.images = [];
                this.template = {};
                if (this.isStatusActive) {
                  this.$refs.imgUpDrop.removeAllFiles(true);
                  this.$refs.fileUpDrop.removeAllFiles(true);
                }
            },
            saveEstimateTemplate: function () {
                if (this.template && this.template.id > 0) {
                    let id = this.template.id;
                    var saveData = JSON.stringify({
                        id: id,
                        images: this.image_ids,
                        files: this.file_ids,
                        parts: this.itemParts,
                        name: this.template.name,
                        removeParts: this.removeItemParts,
                        removeImages: this.removeImages,
                        removeFiles: this.removeFiles,
                    });

                    if (saveData != this.originalData) {
                        //console.log("saveData", saveData);
                        Axios({
                            method: 'post',
                            responseType: 'json',
                            url: `/fe/estimate-templates/${id}`,
                            validateStatus: function (status) {
                                return status < 500;
                            },
                            data: saveData
                        })
                            .then(response => {
                                if (response.status === 200) {
                                    if (response.data.status) {
                                        this.loadEstimateTemplates();
                                        this.initCurrentTemplate();
                                        this.editEstimateTemplate(id);
                                        toastr.success('Estimate Template was updated');

                                    } else {
                                        toastr.error(response.data.msg);
                                    }
                                } else {
                                    toastr.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                toastr.error(error);
                            });

                    }

                }
            },
            removeEstimateTemplate: function (id) {
                if (!this.isStatusActive) {
                  return;
                }
                if (id && id > 0) {
                    Axios({
                        method: 'post',
                        responseType: 'json',
                        url: `/fe/estimate-templates/${id}/delete`,
                        validateStatus: function (status) {
                            return status < 500;
                        },
                        data: {delete: id}
                    })
                        .then(response => {
                            if (response.status === 200) {
                                if (response.data.status) {
                                    if (id == this.template.id) {
                                        this.initCurrentTemplate();
                                    }
                                    this.template = {};
                                    this.loadEstimateTemplates();
                                } else {
                                    toastr.error(response.data.msg);
                                }
                            } else {
                                toastr.error(response.data.msg);
                            }
                        })
                        .catch(error => {
                            toastr.error(error);
                        });
                }
            },
            editEstimateTemplate: function (id) {
                if (id && id > 0) {
                    NProgress.start();
                    this.initCurrentTemplate();

                    Axios({
                        method: 'get',
                        responseType: 'json',
                        url: `/fe/estimate-templates/${id}`,
                        validateStatus: function (status) {
                            return status < 500;
                        },
                    })
                        .then(response => {
                            if (response.status === 200) {
                                if (response.data.id) {
                                    this.template = response.data;
                                    if (response.data.images) {
                                        this.images = response.data.images;
                                    } else {
                                        this.images = [];
                                    }
                                    if (response.data.files) {
                                        this.files = response.data.files;
                                    } else {
                                        this.files = [];
                                    }
                                    if (response.data.parts) {
                                        this.itemParts = response.data.parts;
                                    } else {
                                        this.itemParts = {
                                            'RR': [],
                                            'Repair': [],
                                            'Paint': [],
                                            'Part': [],
                                            'Sublet': [],
                                            'Other': []
                                        };
                                    }
                                    this.removeItemParts = {
                                        'RR': [],
                                        'Repair': [],
                                        'Paint': [],
                                        'Part': [],
                                        'Sublet': [],
                                        'Other': []
                                    };
                                    this.originalData = JSON.stringify({
                                        id: response.data.id,
                                        images: this.images,
                                        files: this.files,
                                        parts: this.itemParts,
                                        removeParts: this.removeItemParts,
                                        removeImages: this.removeImages,
                                        removeFiles: this.removeFiles,
                                    });
                                } else {
                                    toastr.error(response.data.msg);
                                }
                                NProgress.done();
                            } else {
                                toastr.error(response.data.msg);
                                NProgress.done();
                            }
                        })
                        .catch(error => {
                            toastr.error(error);

                        });
                    NProgress.done();
                }
            },
            createEstimateTemplate: function () {
                if (!this.isStatusActive) {
                  return;
                }
                if (this.new_estimate_template_name == '') {
                    return false;
                }
                this.initCurrentTemplate();
                var vm = this;
                Axios({
                    method: 'post',
                    responseType: 'json',
                    url: `/fe/estimate-templates/new`,
                    validateStatus: function (status) {
                        return status < 500;
                    },
                    data: {name: vm.new_estimate_template_name}
                })
                    .then(response => {
                        if (response.status === 200) {
                            if (response.data.id) {
                                vm.ET = response.data.estimate_templates;
                                vm.template = response.data.current_template;
                                vm.new_estimate_template_name = '';
                            } else {
                                toastr.error('error');
                            }
                        } else {
                            toastr.error('error');
                        }
                    })
                    .catch(error => {
                        toastr.error(error);
                    });

            },

            openMenuRR: function (e, index) {
                this.$refs.rightClickMenuForRR.open(e, index);
            },
            openMenuRepair: function (e, index) {
                this.$refs.rightClickMenuForRepair.open(e, index);
            },
            openMenuPaint: function (e, index) {
                this.$refs.rightClickMenuForPaint.open(e, index);
            },
            openMenuPart: function (e, index) {
                this.$refs.rightClickMenuForPart.open(e, index);
            },
            openMenuSublet: function (e, index) {
                this.$refs.rightClickMenuForSublet.open(e, index);
            },
            openMenuOther: function (e, index) {
                this.$refs.rightClickMenuForOther.open(e, index);
            },
            insertNewItem(newItem, index) {
              let partsCopy = _.cloneDeep(this.itemParts[this.selectedCard])
              partsCopy.splice(index + 1, 0, newItem);
              this.itemParts[this.selectedCard] = [];
              setTimeout(() => {
                this.itemParts[this.selectedCard] = partsCopy;
                let id = this.selectedCard + (index + 1);
                setTimeout(() => {
                  this.$refs[id][0].getFocus();
                }, 50);
              }, 0);
            },
            onRightClickByRR(item, data) {
                var index = data.index;
                var elem = this.itemParts['RR'][index];
                if (data.type == 2) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: '',
                        rate: 0,
                        total: 0,
                    };

                    this.insertNewItem(newItem, index)
                } else if (data.type == 3) {
                    this.removeItemPart('RR', index);
                } else if (data.type == 5) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: elem.name,
                        paint_type: 'not_set',
                        rate: 0,
                        total: 0,
                    };
                    var vm = this;
                    setTimeout(() => {
                        vm.itemParts['Paint'].push(newItem);
                    }, 50);
                }
            },
            onRightClickByRepair(item, data) {
                var index = data.index;
                var elem = this.itemParts['Repair'][index];
                if (data.type == 2) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: '',
                        rate: 0,
                        total: 0,
                    };
                    this.insertNewItem(newItem, index)
                } else if (data.type == 3) {
                    this.removeItemPart('Repair', index);
                } else if (data.type == 5) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: elem.name,
                        paint_type: 'not_set',
                        rate: 0,
                        total: 0,
                    };
                    var vm = this;
                    setTimeout(() => {
                        vm.itemParts['Paint'].push(newItem);
                    }, 50);
                }
            },
            onRightClickByPaint(item, data) {
                var index = data.index;
                if (data.type == 2) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: '',
                        paint_type: 'not_set',
                        rate: 0,
                        total: 0,
                    };
                    this.insertNewItem(newItem, index)
                } else if (data.type == 3) {
                    this.removeItemPart('Paint', index);
                }
            },
            onRightClickByPart(item, data) {
                var index = data.index;
                if (data.type == 2) {
                    var newItem = {
                        part_num: '',
                        type: 'New',
                        mup: 0,
                        qty: 1,
                        id: null,
                        name: '',
                        rate: 0,
                        total: 0
                    };
                    this.insertNewItem(newItem, index)

                } else if (data.type == 3) {
                    this.removeItemPart('Part', index);
                }
            },
            onRightClickByOther(item, data) {
                var index = data.index;
                if (data.type == 2) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: '',
                        rate: 0,
                        total: 0,
                    };
                    this.insertNewItem(newItem, index)
                } else if (data.type == 3) {
                    this.removeItemPart('Other', index);
                }
            },
            onRightClickBySublet(item, data) {
                var index = data.index;
                var elem = this.itemParts['Sublet'][index];
                if (data.type == 2) {
                    var newItem = {
                        hrs: 0,
                        id: null,
                        name: '',
                        rate: 0,
                        total: 0,
                    };
                    this.insertNewItem(newItem, index)
                } else if (data.type == 3) {
                    this.removeItemPart('Sublet', index);
                }
            },
            sctollToTop: function () {
                setTimeout(() => {
                    document.getElementsByClassName('modal-dialog')[0].scrollIntoView();
                    return true;
                }, 100);
            },
            onImageSelect: function (imgs) {
                // console.log(imgs)
                this.selectedImages = imgs;
            },
            clickBrowse: function (id) {
                $(id).trigger("click");
            },
            clickCancelDropzoneImages: function () {
                this.$refs.imgUpDrop.removeAllFiles(true);
                this.image_ids = [];
            },
            clickCancelDropzoneFiles: function () {
                this.$refs.fileUpDrop.removeAllFiles(true);
                this.file_ids = [];
            },
            removeFileDropzone($event) {
                let filesReplace = [];

                this.files.forEach((file) => {
                    if (!file.uuid) {
                        filesReplace.push(file);
                    } else if (file.uuid && file.uuid !== $event.upload.uuid) {
                        filesReplace.push(file);
                    }
                });
                this.files = filesReplace;
            },
            sendImgUpload($event) {
                $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = "none";
            },
            sendFileUpload($event) {
                $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = "none";
                let reader = new FileReader();
                reader.onload = (e) => {
                    let fileBase60Code = e.target.result;
                    this.addFile({
                        name: $event.name,
                        src: fileBase60Code,
                        user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
                        date: '',
                        uuid: $event.upload.uuid
                    });
                };
                reader.readAsDataURL($event);
            },
            sendFileRemove: function (file) {
                NProgress.start();
                let url = '/fe/card/sendFileRemove';
                Axios({
                    method: 'post',
                    responseType: 'json',
                    url: url,
                    validateStatus: function (status) {
                        return status < 500;
                    },
                    data: {key: file.key, id: file.id, card_id: this.card_id}
                })
                    .then(response => {
                        if (response.status == 200) {
                            // toastr.success(response.data.msg);

                        } else {
                            // toastr.error(response.data.msg);
                        }
                        NProgress.done();

                    })
                    .catch(error => {
                        NProgress.done();
                        toastr.error(error);
                    });
            },

            remTableFile: function (id) {
              if (!this.isStatusActive) {
                return;
              }
              const index = this.files.findIndex(file => file.id === id);
              if (this.files[index].id != null) {
                this.removeFiles.push(this.files[index].id);
              }
              this.files.splice(index, 1);
            },

          completeImgUpload($event) {
                $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute("style");
            },
            completeFileUpload($event) {
                $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute("style");
            },
            successImgUpload(file, response) {
                if (response.status) {
                    this.image_ids.push(response.file_id);
                    //  this.autoUpdateImage();
                }
            },
            successFileUpload(file, response) {
                if (response.status) {
                    this.file_ids.push(response.file_id);
                    //this.autoUpdateFile();
                }
            },
            addImgUpload($event) {
                $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = "none";
            },
            addFileUpload($event) {
                $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = "none";
            },
            deleteImage: function (index) {
                if (!this.isStatusActive) {
                  return
                }
                if (this.images[index].id != null) {
                    this.removeImages.push(this.images[index].id);
                }
                this.images.splice(index, 1);
                // toastr.success(filename + ' has been deleted');
            },
            saveData: function () {

                if (this.changeEstimentChapter === 'Images' && this.$refs.imgUpDrop.dropzone.files.length) {
                    let vm = this.$refs.imgUpDrop;
                    let files = this.$refs.imgUpDrop.dropzone.files;

                    if (!files.length) {
                        vm.$emit('input', '');
                        return;
                    }
                    files.forEach((item, i) => {
                        if (item.accepted) {
                            this.addImage({
                                name: item.name,
                                src: item.dataURL,
                                user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
                                date: ''
                            });
                        }
                    });
                }
                let estimate_id = this.$route.params.estimate_id;
                // let obj = this
                if (this.validateForm()) {
                    return;
                }
                this.files.forEach((file, i) => {
                    if (file.uuid) {
                        delete file.uuid;
                    }
                });
                NProgress.start();
                Axios({
                    method: 'post',
                    responseType: 'json',
                    url: `/fe/estimate/${estimate_id}`,
                    validateStatus: function (status) {
                        return status < 500;
                    },
                    data: JSON.stringify({
                        estimate: this.estimate,
                        card: this.card,
                        //  parts: this.estimateTemplateParts,
                        // removeParts: this.removeestimateTemplateParts,
                        file_ids: this.file_ids,
                        image_ids: this.image_ids,
                        draft: isDraft,
                        status: this.status,
                        insurance: this.card.insurance,
                        insurance_repair: this.card.insurance_repair
                    })
                })
                    .then(response => {
                        if (response.status == 200) {
                            if (isDraft == 'N') {
                                toastr.success('Estimate updated');
                                // this.$router.push('/estimates')
                            } else {
                                toastr.success('Draft saved!');
                                // this.$router.push('/estimates/drafts')
                            }
                            this.removeestimateTemplateParts = {
                                'RR': [],
                                'Repair': [],
                                'Paint': [],
                                'Part': [],
                                'Materials': [],
                                'Sublet': [],
                                'Other': []
                            };
                            this.loadEstimate(estimate_id);
                            if (this.isStatusActive) {
                              this.$refs.imgUpDrop.removeAllFiles(true);
                              this.$refs.fileUpDrop.removeAllFiles(true);
                            }

                            this.file_ids = [];
                            this.image_ids = [];

                            // this.$router.push('/files')
                        } else {
                            toastr.error(response.data.msg);
                        }
                        NProgress.done();
                    })
                    .catch(error => {
                        NProgress.done();
                        toastr.error(error);
                    });
            },

            loadEstimateTemplates: function () {
                NProgress.start();
                Axios.get(`/fe/estimate-templates`)
                    .then(response => {
                        this.ET = response.data.data;
                        NProgress.done();
                    })
                    .catch(error => {
                        toastr.error("Error");
                        // console.log(error)
                        NProgress.done();
                        this.$router.push('/files');
                    });
            },
            addImage: function (img) {
                // console.log(img)
                if (img.src == '' || img.src === undefined || img.src === null) {
                    return;
                } else {
                    this.images.unshift(img);
                    this.newImageAdded = true;
                }
            },
            addFile: function (file) {
                if (file.src == '' || file.src === undefined || file.src === null) {
                    return;
                } else {
                    this.files.unshift(file);
                    this.newFileAdded = true;
                }
            },
            selectCard: function (card) {
                this.selectedCard = card;
            },
            selectCardPart: function (part) {
                this.selectedCardPart = part;
            },
            onKeyPress: function (event) {

            },
            onUpKeyPress: function (index, fieldName) {
                let maxParts = this.selectedCardPartsCount;

                index -= 1;

                if (index < 0) {
                    index = maxParts - 1;
                }

                let id = this.selectedCard + index;
                setTimeout(() => {
                    this.$refs[id][0].getFocus(fieldName);
                }, 100);
            },
            onRightLeftKeyPress: function (index, fieldName) {
                let id = this.selectedCard + index;
                setTimeout(() => {
                    this.$refs[id][0].getFocus(fieldName);
                }, 100);
            },
            onRightKeyPress: function (index, fieldName) {
                this.onRightLeftKeyPress(index, fieldName);
            },
            onLeftKeyPress: function (index, fieldName) {
                this.onRightLeftKeyPress(index, fieldName);
            },
            onDownKeyPress: function (index, fieldName) {
                let maxParts = this.selectedCardPartsCount;

                index += 1;

                if (index >= maxParts) {
                    index = 0;
                }

                let id = this.selectedCard + index;
                setTimeout(() => {
                    this.$refs[id][0].getFocus(fieldName);
                }, 100);
            },
            onEnterKeyPress: function (index) {
                this.selectCardSubPart('');

                if (this.selectedCardSubPart == undefined) {
                    return;
                }

                if (index >= this.selectedCardPartsCount - 1) {
                    return;
                }

                let id = this.selectedCard + (index + 1);

                setTimeout(() => {
                    this.$refs[id][0].getFocus();
                }, 100);
            },
            selectCardSubPart: function (sp, isAddToStart = false) {
                if (!this.isStatusActive) {
                  return;
                }
                this.selectedCardSubPart = sp.prt;
                let tmp = 0;
                let id = '';
                let selectedParts = this.itemParts[this.selectedCard];
                if (selectedParts) {
                    for (let i = 0; i < selectedParts.length; i++) {
                        if (sp.prt === selectedParts[i].name) {
                            id = this.selectedCard + i;
                            setTimeout(() => {
                                this.$refs[id][0].getFocus();
                            }, 100);
                            return;
                        }
                    }
                }
                let default_rate = 0;
                if (this.selectedCard == 'Part') {
                    var newItem = {
                        id: null,
                        name: sp.prt,
                        part_num: '',
                        type: 'New',
                        mup: 0,
                        qty: 1,
                        rate: 0,
                        total: 0
                    };

                } else if (this.selectedCard == 'Paint') {
                    var newItem = {
                        id: null,
                        name: sp.prt,
                        paint_type: 'not_set',
                        hrs: 0,
                        rate: default_rate,
                        total: 0
                    };
                } else {
                    var newItem = {
                        id: null,
                        name: sp.prt,
                        rate: default_rate,
                        hrs: sp.hrs,
                        total: 0
                    };
                }
                console.log(newItem, 'new Item', isAddToStart)
                if (isAddToStart) {
                  let partsCopy = _.cloneDeep(this.itemParts[this.selectedCard])
                  partsCopy.unshift(newItem);
                  this.itemParts[this.selectedCard] = [];
                  setTimeout(() => {
                    this.itemParts[this.selectedCard] = partsCopy;
                    id = this.selectedCard + 0;
                    setTimeout(() => {
                      this.$refs[id][0].getFocus();
                    }, 50);
                  }, 0);
                } else {
                  this.itemParts[this.selectedCard].push(newItem);
                  id = this.selectedCard + (this.selectedCardPartsCount - 1);
                  setTimeout(() => {
                    this.$refs[id][0].getFocus();
                  }, 50);
                }
            },

            onDragEstimateItemStart () {
              this.isMovedElement = false
            },
            onDragEstimateItemEnd () {
              this.isMovedElement = true
            },
            onItemMoveChange: function (event) {
              let partsCopy = _.cloneDeep(this.itemParts[this.selectedCard])
              this.itemParts[this.selectedCard] = [];
              setTimeout(() => {
                this.itemParts[this.selectedCard] = partsCopy;
              }, 0);
              if (!event) return false

              // console.log('onItemMoveChange', event);
              if (!event.moved && !event.dragged) {
                return false
              }

                //    this.beforeDebouncedUnsavedChanges();
                var card = this.selectedCard;
                var sort = [];
                if (this.itemParts[card]) {
                    this.itemParts[card].forEach(function (el, index) {
                        sort.push({id: el.id, index: index});
                    });
                }

                this.sort.push({sort: sort, card: card});
                //   this.beforeDebouncedAutoSave();
                return true;

                var el = this.itemParts[card][newIndex];
                if (el) {
                    var id = el.id;
                    if (newIndex == 0) {
                        var sort_id = 0;
                    } else {
                        var sort_el = this.itemParts[card][newIndex - 1];
                        if (sort_el) {
                            var sort_id = sort_el.id;
                        } else {
                            return false;
                        }
                    }
                    if (!this.updateData.sort) {
                        this.updateData.sort = [];
                    }
                    this.updateData.sort.push({id: id, sort: sort_id, sort2: (newIndex - oldIndex), card: card});
                    this.beforeDebouncedAutoSave();
                    return true;
                }
                return false;
            },
            getFocus: function (el) {
                if (el) {
                    document.getElementById(el).focus();
                }
            },
            dismissError: function () {
                this.error.exists = false;
            },
            refreshItemsList: function () {
                console.log(this.cardSubParts);
            },
            removeItemPart(card, index) {
                if (!this.isStatusActive) {
                  return;
                }
                var vm = this;
                if (vm.itemParts[card][index].id != null) {
                    vm.removeItemParts[card].push(vm.itemParts[card][index].id);
                }
                var c = vm.itemParts[card];
                c.splice(index, 1);
                vm.itemParts[card] = [];
                setTimeout(() => {
                    vm.itemParts[card] = c;
                }, 20);
            }
        },
        mounted: function () {
            this.loadEstimateTemplates();
            if(sessionStorage.selectedTemplateId){
              this.editEstimateTemplate(sessionStorage.selectedTemplateId);
              sessionStorage.selectedTemplateId = false;
            }
        },
        computed: {
            ...mapGetters({
              isStatusActive: 'isStatusActive',
            }),
            computedIsMovedDraggableElement () {
              return this.isMovedElement
            },
            isCurrentTemplate: function () {
                if (this.template && this.template.id > 0) {
                    return true;
                }
                return false;
            },
            totalImages: function () {
                return this.images.length;
            },
            totalFiles: function () {
                return this.files.length;
            },
            totalSupplements: function () {
                return this.supplements.length;
            },
            totalParts: function () {
                return this.itemParts['RR'].length + this.itemParts['Repair'].length + this.itemParts['Paint'].length + this.itemParts['Part'].length + this.itemParts['Sublet'].length + this.itemParts['Other'].length;
            },
            selectedCardPartsCount: function () {
                return this.itemParts[this.selectedCard].length;
            },
            cards: function () {
                return this.$store.state.partCategories;
            },
            cardParts: function (card) {
                try {
                    if (this.magicSearchCardPart == '') {
                        return _.keys(this.cards[this.selectedCard]);
                    }
                    var st = this.magicSearchCardPart;//.toUpperCase()
                    return _.filter(this.cardPartsCombined, function (i) {
                        return i.match(new RegExp(st, "i"));
                    });
                } catch (erro) {
                    return [];
                }
            },
            cardPartsCombined: function () {
                try {
                    return _.flatten(_.keys(this.cards[this.selectedCard]));
                } catch (error) {
                    return [];
                }
            },
            estimateTemplates: function () {
                try {
                    if (this.magicSearchEstimateTemplate == '') {
                        return this.ET;
                    }

                    var st = this.magicSearchEstimateTemplate;//.toUpperCase()
                    return _.filter(this.ET, function (i) {
                        return i.name.match(new RegExp(st, "i"));
                    });
                } catch (error) {
                    return [];
                }
            },
            cardSubParts: function () {
                try {
                    if (this.magicSearchSubCardPart == '') {
                        return this.cards[this.selectedCard][this.selectedCardPart];
                    }

                    var st = this.magicSearchSubCardPart;//.toUpperCase()
                    return _.filter(this.cardSubPartsCombined, function (i) {
                        return i.prt.match(new RegExp(st, "i"));
                    });
                } catch (error) {
                    return [];
                }
            },
            cardSubPartsCombined: function () {
                try {
                    return _.flatten(_.values(this.cards[this.selectedCard][this.selectedCardPart]));
                } catch (error) {
                    return [];
                }
            },
            imageSource: function () {
                try {
                    // console.log(this.images)
                    // console.log('lodash-> ', _.map(this.images, 'src'))
                    return _.map(this.images, 'src');
                    //return this.images;
                } catch (erro) {
                    return [];
                }
            },
            availableCards: function () {
                try {
                    return _.keys(this.itemParts);
                } catch (erro) {
                    return [];
                }
            },
            vendorInfo: function () {
                return this.$store.state.vendorInfo;
            },
            userInfo: function () {
                return this.$store.state.userInfo;
            },
            totalFiles: function () {
              return this.files.length;
            },

            fromFiles: function() {
              if (!this.files) return 0;
              else return (this.cardsCurrentPage - 1) * this.cardsPerPage + 1;
            },

            toFiles: function() {
              const toFiles = (this.cardsCurrentPage - 1) * this.cardsPerPage + this.cardsPerPage;
              if (toFiles > this.totalFiles) return this.totalFiles;
              return toFiles;
            }
        },
        components: {
            FileUploader,
            RsRipple,
            ImageLightbox,
            SiteFooter,
            NumberFormatter,
            EstimateItem,
            AdvancedSearch,
            ImageSelector,
            DatePicker,
            draggable,
            AmazonAds,
            vueDropzone: vue2Dropzone,
            VueContext,
            GoogleLocation,
            FormWizard,
            TabContent,
            WizardStep,
            BlockPagination,
        }
    };
</script>

<style>
  .ghost-items {
    display: flex;
    width: 100%;
    background-color: #F9F9F9 !important;
    border: 2px solid rgba(94, 121, 255, 0.5) !important;
    box-shadow: 0 0 0 0.3rem rgba(94, 121, 255, 0.25);
    border-radius: 3px;
    box-sizing: border-box;
  }

  .ghost-items a {
    color: #5E6571;
    font-family: "Nunito Sans", sans-serif;
    font-size: 12px;
    font-stretch: 100%;
    background: white;
    border: 1px solid rgba(28, 31, 57, 0.25);
    border-radius: 3px;
    width: calc(100% - 1.5rem);
    line-height: 32px;
    padding: 0 2px;
    display: block;
    margin: .75rem;
  }

  .ghost-items a:hover {
    color: #5E6571;
  }

  .ghost-items a > div {
    display: none !important;
  }

  .ghost-items::after {
    content: "";
  }

  .estimates-template h4 span {
      font-weight: 500;
  }

  .estimates-template h4 {
    padding-left: 12px;
      padding-top:24px;
      padding-bottom:24px;
      border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  .estimates-template .template-modify-info{
      border-bottom: 10px solid rgb(241,241,247);
      padding: 7px 15px 13px 15px;
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
  }
  .estimates-template .template-modify-info span:nth-child(odd){
      color:rgba(0,0,0,0.5);
      padding-top: 10px;
      display: inline-block;
  }
  .estimates-template .template-modify-info span:nth-child(even) a{
      color:black;
      margin-right:30px;
  }
  .estimates-template .tab-pane {
      background: white;
  }
  .estimates-template .container-fluid .row .col-md-3{
      padding:0px!important;
  }
  .estimates-template .container-fluid .row .col-md-9{
      padding:0px!important;
  }
  .estimates-template ul.nav.nav-4{
      background: white;
      border: 1px solid rgba(0,0,0,0.2);
      border-radius: 6px;
      margin-right: 10px;
  }
  .estimates-template ul.nav.nav-4 li{
      position: relative;
  }
  .estimates-template ul.nav.nav-4 li a:hover{
      background:white;
  }
  .estimates-template ul.nav.nav-4 .nav-item.active{
      background-color: rgba(94,121,255,0.1)!important;
  }
  .estimates-template ul.nav.nav-4 .nav-item.active a:focus{
      background-color: rgba(94,121,255,0.1)!important;
  }
  .estimates-template ul.nav.nav-4 .nav-item.active .nav-link{
      color:black;
  }
  .estimates-template ul.nav.nav-4 .nav-item.active::after{
      content: "";
      position: absolute;
      left:0px;
      bottom:0px;
      height: 100%;
      width:5px;
      border-radius: 0 5px 5px 0;
      background-color: #5E79FF;;
  }
  .estimates-template .tab-pane .col-md-5 .col-md-6{
      padding-left:0px!important;
      padding-right:0px!important;
  }
  .estimates-template .new-estimate-item{
      color:#5E79FF!important;
  }
  .estimates-template .new-estimate-item i{
      color:#5E79FF!important;
  }
  .estimates-template .search-input{
      background: url('data:image/svg+xml;base64,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') no-repeat center right;
      background-position: right 7px center;
      width:100%;
  }
  .estimates-template .search-input:focus{
      width:100%!important;
  }
  @media screen and (max-width: 767px) {
    .estimates-template .active.ml-2 {
          margin-left: 0 !important;
      }
  }

  .estimates-template .left-side {
      background: #DFEBF8;
      padding-bottom: 110px;
  }

  .estimates-template .left-side hr {
      width: 100%;
      border-bottom: 2px solid #C0D8EF;
      margin: 20px 0;
  }

  .estimates-template .left-side h3 {
      color: #142742;
      font-size: 14px;
      font-weight: bold;
      line-height: 19px;
      margin-top: 20px;
      margin-bottom: 10px;
  }

  .estimates-template .p-20 {
      padding: 20px;
  }

  .estimates-template .mt-3 {
      margin-top: 2.3rem !important;
  }

  .estimates-template .btn.btn-primary.mt-1.mb-1 {
      margin-bottom: 0.5rem;
  }

  .estimates-template .filed-md {
      display: block;
      width: 100%;
      background: #FFFFFF;
      font-size: 14px;
      font-weight: 600;
      border: 1px solid #DDDDDD;
      padding: 15px;
      border-radius: 3px;
  }

  .estimates-template .filed-md::placeholder {
      color: #818A91;
      font-size: 14px;
      font-weight: 600;
  }

  .estimates-template .search-field {
    background: url('data:image/svg+xml;base64,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') no-repeat center right white;
    background-position: right 7px center;
    width: 100%;
  }

  .estimates-template .left-side-nav {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

  .estimates-template .left-side-nav li {
        display: flex;
        justify-content: space-between;
        color: #142742;
        font-size: 14px;
        padding: 13px 20px;
        -webkit-transition: 0.2s linear;
        -moz-transition: 0.2s linear;
        -o-transition: 0.2s linear;
        transition: 0.2s linear;
    }

  .estimates-template .left-side-nav li:hover {
        background: #fbfdfe;
        color: #0672C3;
    }

  .estimates-template .left-side-nav li.active {
        background: #EFF5FA;
    }

  .estimates-template .left-side-nav button {
        cursor: pointer;
        width:20px;
        padding: 0;
        margin-left:5px;
    }

  .estimates-template .left-side-nav i {
        font-size: 20px;
        margin-left: 10px;
    }

  .estimates-template .left-side-nav .ti-write {
        color: #142742;
    }

  .estimates-template .left-side-nav .ti-trash {
        color: #D0021B;
    }

  .estimates-template .dropzoneContainer {
    margin: 10px 15px;
    width: auto;
    border: 1px dashed rgba(27, 30, 56, .25);
    border-radius: 3px;
    background: none !important;
    height: auto;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
  }

  .estimates-template .dropzoneContainer .dropify-message  .bx {
    font-size: 37px;
    color: #5E79FF;
  }

  .estimates-template .dropzoneContainer .dnd-title {
    color: #1C1F39;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
  }

  .estimates-template .dropify-wrapper .dropify-message span.file-icon:before {
    content: '\E800';
    font-weight: 800;
    font-size: 37px;
    color: blue;
  }

  .estimates-template .dropify-wrapper .dropify-message .drop-down-text {
    font-family: "Nunito Sans";
    color: #1C1F39;
    font-size: 13px;
    font-weight: bold;
  }

  .estimates-template .table-responsive > table > thead {
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
    line-height: 18px;
  }

  .estimates-template .table-responsive .file-name {
    width: 400px;
    max-width: 400px;
    cursor: pointer;
    color: #5E79FF;
    font-family: "Nunito Sans";
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    overflow-wrap: break-word;
  }

  .estimates-template .table-responsive .file-name:hover {
    text-decoration: underline;
  }

  .estimates-template .table-responsive .uploaded-by {
    width: 300px;
    max-width: 300px;
    color: #1C1F39;
    font-family: "Nunito Sans";
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
  }

  .estimates-template .table-responsive .uploaded-date {
    width: 300px;
    max-width: 300px;
    color: #1C1F39;
    font-family: "Nunito Sans";
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  .estimates-template .table-responsive i {
      font-size: 37px;
      color: #5E79FF
    }

  .estimates-template .table-responsive .action {
    width: 100px;
    max-width: 100px;
    padding-top: 11px;
  }

  .estimates-template .table-responsive .trash-icon {
    cursor: pointer;
  }

  .estimates-template .table-responsive .dnd-or {
    opacity: 0.25;
    color: #1C1F39;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
  }

  .btn-right {
      margin-left: auto;
  }
</style>

<style>
    .template-estimate-items-title {
        height: 48px;
        background-color: rgba(27, 30, 56, .1) !important;
        color: #1C1F39 !important;
        font-size: 13px;
        font-weight: 700;
        line-height: 18px;
        display: flex;
        align-items: center;
    }

    .template-estimate-items-title-content {
        padding: 0.75rem;
        width: 95px;
        flex-grow: 0;
    }

    #estimate-item-list .template-estimate-items .has-line {
        margin-bottom: 34px;
    }

    #estimate-item-list .template-estimate-items .has-line-x2 {
        margin-bottom: 75px;
    }

    #estimate-item-list .template-estimate-items .comment-block {
        position: absolute;
        left: 0px;
        width: 100%;
        margin-top: 55px;
        padding-left: 0px;
    }

    #estimate-item-list .template-estimate-items .comment-block .comment-text {
        height: 32px;
        padding-left: 20px;
        padding-top: 4px;
        color: #FE9600;
    }

    #estimate-item-list .template-estimate-items .comment-block .comment-text span,
    #estimate-item-list .template-estimate-items .comment-block .estimate-comment-text span {
        font-weight: bold;
    }

    #estimate-item-list .template-estimate-items .comment-block .estimate-comment-text {
        height: 32px;
        padding-left: 20px;
        padding-top: 4px;
        color: #3CD6B2;
    }

    #estimate-item-list .template-estimate-items {
        margin-bottom: 10rem !important;
    }

    .template-width-parts {
        min-width: 810px;
    }
    .template-width-paint {
        min-width: 685px;
    }
    .template-width-other{
        min-width: 605px;
    }
    .estimate-items-title-content {
        padding: 0.75rem;
        width: 95px;
        flex-grow: 0;
    }

    .template-estimate-items .numeric {
        text-align: right;
    }

    .template-estimate-items .form-control {
        height: 32px !important;
    }
</style>
